import React from 'react';

const SVGWarningBang = props => {
  return (
    <span className="svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <defs>
          <style>{'.bang{fill:#fff;}'}</style>
        </defs>
        <title>Warning</title>
        <circle className="cls-1" cx="10" cy="10" r="10" />
        <path
          className="bang"
          d="M9.63,12.56l-.27-3.8V7.18h1.09V8.76l-.26,3.8ZM9.4,14.33v-1h1v1Z"
        />
      </svg>
    </span>
  );
};

export default SVGWarningBang;



// WEBPACK FOOTER //
// ./src/svg/WarningBang.js